export default {
  state: {
    supplierCategories: [],
    loading: false,
  },
  getters: {
    supplierCategories: state => state.supplierCategories,
    loading: state => state.loading,
  },
  mutations: {
    setSupplierCategories(state, supplierCategories) {
      state.supplierCategories = supplierCategories;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchAll({ commit }) {
      commit('setLoading', true);
      try {
        const supplierCategories = await axios.get('api/supplier-categories');
        commit('setSupplierCategories', supplierCategories);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetch({ commit }, id) {
      return await axios.get(`api/supplier-categories/${id}`);
    },
    async create({ commit }, payLoad) {
      await axios.post('api/supplier-categories', payLoad);
    },
    async update({ commit }, payLoad) {
      await axios.put('api/supplier-categories', payLoad);
    },
    async delete({ commit }, id) {
      await axios.delete(`api/supplier-categories/${id}`);
    },
  },
};
